import React from 'react';

const ReturnIcon = () => (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" aria-hidden="true">
    <path d="M9 3H3.5A2.5 2.5 0 0 0 1 5.5v0A2.5 2.5 0 0 0 3.5 8H7" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M9 3L7 1M9 3L7 5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

function TimelineSlot({ slot, onDropJob, onUnassign }) {
  const allowDrop = (e) => e.preventDefault();

  const handleDrop = (e) => {
    e.preventDefault();
    const jobId = e.dataTransfer.getData('text/job-id');
    if (jobId) onDropJob(jobId, slot.id);
  };

  return (
    <li className="dispatch-timeline-slot">
      <div className="dispatch-timeline-time">
        <strong>{slot.time}</strong>
      </div>
      <div
        className={`dispatch-timeline-dropzone${slot.job ? ' has-job' : ''}`}
        onDragOver={allowDrop}
        onDrop={handleDrop}
        aria-label={`Timeline slot ${slot.time}${slot.job ? `, assigned: ${slot.job.title}` : ', empty'}`}
      >
        {slot.job ? (
          <article className="dispatch-timeline-job">
            <div className="dispatch-timeline-job-info">
              <p className="dispatch-job-id">{slot.job.id}</p>
              <h3 className="dispatch-job-title">{slot.job.title}</h3>
              <p className="dispatch-job-meta">{slot.job.customer}</p>
            </div>
            <button
              type="button"
              className="ui-button ui-button--ghost ui-button--sm"
              onClick={() => onUnassign(slot.id)}
              aria-label={`Return ${slot.job.title} to queue`}
              style={{ flexShrink: 0 }}
            >
              <ReturnIcon />
              Return
            </button>
          </article>
        ) : (
          <p className="dispatch-slot-empty">Drop a job here</p>
        )}
      </div>
    </li>
  );
}

export function DispatchTimeline({ timeline, onDropJob, onUnassign }) {
  const assigned = timeline.filter((s) => s.job).length;

  return (
    <div className="dispatch-pane">
      <div className="dispatch-pane-header">
        <span className="dispatch-pane-title">Live Timeline</span>
        <span className="dispatch-pane-count">{assigned}/{timeline.length}</span>
      </div>
      <ul className="dispatch-timeline-list" role="list">
        {timeline.map((slot) => (
          <TimelineSlot
            key={slot.id}
            slot={slot}
            onDropJob={onDropJob}
            onUnassign={onUnassign}
          />
        ))}
      </ul>
    </div>
  );
}
